import React, { useState, useEffect, useContext } from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import RemoveIcon from '@mui/icons-material/Remove';


import { ListingContext } from '../../contexts/ListingContext';


import './ManageOperators.css'


const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function ManageFeatured() {
  const { getFeatured, featured, getPublishedListings, publishedListings, updateFeatured } = useContext(ListingContext)
  const [featuredTours, setFeaturedTours] = useState([
    {
      listing: '',
      order: 0
    }
  ])

  useEffect(() => {
    getPublishedListings()
    getFeatured()
  }, [])

  useEffect(() => {
    if (featured.length > 0) {
      // setFeaturedTours
      setFeaturedTours(featured.map(e => {
        return (
          {
            listing: e.name,
            order: e.featuredOrder
          }
        )
      }))
    }
  }, [featured, publishedListings])


  const handleChange = (e, i) => {
    const { name, value } = e.target;

    let arr = featuredTours
    arr[i] = {
      ...arr[i],
      [name]: value
    }

    setFeaturedTours([...arr]);
  }

  const handleAddNew = () => {
    setFeaturedTours([
      ...featuredTours,
      {
        listing: '',
        order: 0
      }
    ])
  }

  const handleRemove = (i) => {
    let arr = featuredTours
    arr.splice(i, 1)
    setFeaturedTours([...arr]);
  }

  const handleUpdateFeatured = () => {
    if (featuredTours[0].listing !== '') {
      updateFeatured(featuredTours)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button style={{marginRight: 20}} onClick={getFeatured} variant="contained">Reset</Button>
        <Button onClick={handleUpdateFeatured} variant="contained">Update Featured</Button>
      </div>
      <TableContainer style={{ marginTop: '30px' }} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Listing</TableCell>
              <TableCell>Order</TableCell>
              <TableCell>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button onClick={handleAddNew} variant="contained">Add New</Button>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {featuredTours.map((tour, i) => {
              return (
                <TableRow>
                  <TableCell>
                    <FormControl fullWidth>
                      <Select
                        className="manger-facility-input"
                        value={tour.listing}
                        name="listing"
                        onChange={(e) => handleChange(e, i)}
                      >
                        {publishedListings.map(e => <MenuItem key={e.name} value={e.name}>{e.name}</MenuItem>)}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <FormControl fullWidth>
                      <Select
                        className="manger-facility-input"
                        value={tour.order}
                        name="order"
                        onChange={(e) => handleChange(e, i)}
                      >
                        {featuredTours.map((e, i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <RemoveIcon onClick={() => { handleRemove(i) }} style={{ cursor: 'pointer' }} />
                    </div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default ManageFeatured
